const Columns = [
  {
    id: "orderId",
    numeric: false,
    disablePadding: true,
    label: "Order Id",
    isSortable: true,
    gray: true,
  },
  {
    id: "dateOfRequest",
    numeric: false,
    disablePadding: true,
    label: "Order Date",
    isSortable: true,
    gray: true,
  },
  {
    id: "employeeName",
    numeric: false,
    disablePadding: true,
    label: "Employee Name",
    isSortable: true,
    gray: true,
  },
  {
    id: "clientName",
    numeric: false,
    disablePadding: false,
    label: "Client Name",
    isSortable: true,
    gray: true,
  },
  {
    id: "supplies",
    numeric: false,
    disablePadding: true,
    label: "Supplies",
    isSortable: true,
    gray: true,
  },
  {
    id: "priority",
    numeric: false,
    disablePadding: false,
    label: "Priority",
    isSortable: true,
    gray: true,
  },
  {
    id: "orderStatus",
    numeric: false,
    disablePadding: false,
    label: "Order Status",
    isSortable: true,
    gray: true,
  },
  {
    id: "deliverStatus",
    numeric: false,
    disablePadding: false,
    label: "Deliver Status",
    isSortable: true,
    gray: true,
  },
  {
    id: "action",
    numeric: false,
    disablePadding: true,
    label: "Action",
    gray: true,
    // rowclassName: "pl-40",
    className: "pl-40",
  },
];

const ColumnsRes = [
  {
    id: "clientName",
    numeric: false,
    disablePadding: false,
    label: "Client",
    isSortable: true,
  },
  {
    id: "priority",
    numeric: false,
    disablePadding: false,
    label: "Priority",
    isSortable: true,
  },
  {
    id: "orderStatus",
    numeric: false,
    disablePadding: false,
    label: "Status",
    isSortable: true,
  },
  {
    id: "dateOfRequest",
    numeric: false,
    disablePadding: true,
    label: "Order Date",
    isSortable: true,
    isCollapsible: true,
  },
  {
    id: "supplies",
    numeric: false,
    disablePadding: true,
    label: "Supplies",
    isSortable: true,
    isCollapsible: true,
  },
  {
    id: "employeeName",
    numeric: false,
    disablePadding: true,
    label: "Name",
    isSortable: true,
    isCollapsible: true,
  },
];

export { Columns, ColumnsRes };
